import utils from '../Utils';
import apiClient from './ApiInterceptor';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const fetchEvents = async (branch, fromDate, toDate, onlyCourtesies = false) => {
    try {
        const params = {
            from: dayjs.utc(fromDate).format('YYYY-MM-DD HH:mm:ss'),
            to: dayjs.utc(toDate).format('YYYY-MM-DD HH:mm:ss'),
            branch: branch,
            onlyCourtesies: onlyCourtesies,
          };

        const response = await apiClient.get('/events', { params });
        return response.data;
    } catch (error) {
        console.error('EventsApi - fetchEvents, Error fetching data:', error);
    }
};

export const fetchAttendees = async (event) => {
  try {
    const params = {
      is_unique: event.hasOwnProperty('is_unique') ? event.is_unique : false,
      is_edited: event.hasOwnProperty('is_edited') ? event.is_edited : false,
      start_date: utils.getFormattedDateInUTC(event.start_date),
      end_date: utils.getFormattedDateInUTC(event.end_date),
      event_id: event.event_id,
    };

    const response = await apiClient.get('/events/attendees', { params });
    return response.data;
  } catch (error) {
    console.error('EventsApi - fetchAttendees, Error fetching data:', error);
  }
};

export const fetchBatchAttendees = async (events) => {
  try {
    const formattedEvents = events.map((event) => ({
      event_id: event.event_id,
      is_unique: event.hasOwnProperty("is_unique") ? event.is_unique : false,
      is_edited: event.hasOwnProperty("is_edited") ? event.is_edited : false,
      start_date: event.start_date.format("YYYY-MM-DD HH:mm:ss"),
      end_date: event.end_date.format("YYYY-MM-DD HH:mm:ss"),
      unique_id: event.unique_id,
    }));

    const response = await apiClient.post("/events/attendees/batch", {
      events: formattedEvents,
    });

    const attendeesByUniqueId = response.data;

    return events.map((event) => ({
      ...event,
      attendees: attendeesByUniqueId[event.unique_id] || [],
    }));
  } catch (error) {
    console.error("EventsApi - fetchAllAttendees, Error fetching data:", error);
    return events.map((event) => ({ ...event, attendees: [] }));
  }
};


export const fetchEvent = async (event_id, is_unique, is_edited, start_date, end_date) => {
  try {
    const params = {
      event_id,
      is_unique,
      is_edited,
      start_date: utils.getFormattedDateInUTC(start_date),
      end_date: utils.getFormattedDateInUTC(end_date),
    };
    const response = await apiClient.get(`/events/${event_id}`, { params });
    return response.data;
  } catch (error) {
    console.error('EventsApi - fetchEvent, Error fetching event:', error);
  }
};

export const createEvent = async (payload) => {
  const response = await apiClient.post('/events', payload);
  return response;
};

export const previewEvent = async (payload) => {
  const response = await apiClient.post('/events/preview', payload);
  return response;
};

// Update an existing event
export const updateEvent = async (event_id, payload, scope = 'one', rule_id = null, is_unique = false, is_edited = false) => {
  try {
    let url = `/events/${event_id}?scope=${scope}`;
    if (rule_id) {
      url += `&rule_id=${encodeURIComponent(rule_id)}`;
    }
    if (is_unique) {
      url += `&is_unique=true`;
    }
    if (is_edited) {
      url += `&is_edited=true`;
    }
    const response = await apiClient.put(url, payload);
    return response;
  } catch (error) {
    console.error('EventsApi - updateEvent, Error updating event:', error);
    throw error;
  }
};

// Delete an event
export const deleteEvent = async (event_id, scope = 'one', occurrenceDate = null, rule_id = null, is_unique = false, is_edited = false) => {
  try {
    let url = `/events/${event_id}?scope=${scope}`;
    if (occurrenceDate) {
      const formattedDate = utils.getFormattedDateInUTC(occurrenceDate) || occurrenceDate;
      url += `&occurrence_date=${encodeURIComponent(formattedDate)}`;
    }
    if (rule_id) {
      url += `&rule_id=${encodeURIComponent(rule_id)}`;
    }
    if (is_unique) {
      url += `&is_unique=true`;
    }
    if (is_edited) {
      url += `&is_edited=true`;
    }
    const response = await apiClient.delete(url);
    return response;
  } catch (error) {
    console.error('EventsApi - deleteEvent, Error deleting event:', error);
    throw error;
  }
};
